import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './RegistrationCompleted.scss';

// No props needed anymore
interface RegistrationCompletedProps {}

const RegistrationCompleted: React.FC<RegistrationCompletedProps> = () => {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();

  return (
    <div className="registration-completed">
      <h2 className="registration-completed__title">
        {t('registration.registrationCompleted.title')}
      </h2>
      <p className="registration-completed__message">
        {t('registration.registrationCompleted.message')}
      </p>
      <button 
        className="registration-completed__button" 
        onClick={() => navigate('/new-user-login')}
      >
        {t('registration.registrationCompleted.loginButton')}
      </button>
    </div>
  );
};

export default RegistrationCompleted;
